<app-sidebar>
  <app-search-bar
    [index]="'Resources'"
    [recordType]="'resources'"
    (tileData)="tiles.set($event)"
    (loadingChange)="loading.set($event)"
    [sort]="sort"
  ></app-search-bar>
  <app-search-results [tiles]="tiles()" [loading]="loading()" (infiniteScroll)="onInfiniteScroll($event)" />
</app-sidebar>
